import { render, staticRenderFns } from "./goodsTag.vue?vue&type=template&id=db52fb52&scoped=true"
import script from "./goodsTag.vue?vue&type=script&lang=js"
export * from "./goodsTag.vue?vue&type=script&lang=js"
import style0 from "./goodsTag.vue?vue&type=style&index=0&id=db52fb52&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db52fb52",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('db52fb52')) {
      api.createRecord('db52fb52', component.options)
    } else {
      api.reload('db52fb52', component.options)
    }
    module.hot.accept("./goodsTag.vue?vue&type=template&id=db52fb52&scoped=true", function () {
      api.rerender('db52fb52', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/store/goodsTag/goodsTag.vue"
export default component.exports